module.exports = __webpack_public_path__ + "static/img/far1_active.f4725f46.png";